export enum ResourceType {
  BROKERAGE = "brokerage",
  QUOTE = "quote",
  ROLE = "role",
}
